module.exports = __webpack_public_path__ + "static/media/ShardMeetingRoom17.50280126.jpg";